import React from 'react';
import { ComplianceProvider } from '@fiverr-private/compliance';

export interface ListingsContextProps {
    children: React.ReactNode;
    complianceData?: Omit<React.ComponentProps<typeof ComplianceProvider>, 'children'>;
}

export const ListingsContext = ({ children, complianceData }: ListingsContextProps) => {
    if (!complianceData) return <>{children}</>;

    return <ComplianceProvider {...complianceData}>{children}</ComplianceProvider>;
};
